import PageLayout from "../../../shared/ui/layouts/PageLayout/PageLayout";
import { SegmentedControl } from "../../../shared/ui/controls/SegmentedControl";
import {
  toRescheduleFiltersForm,
  useRescheduleFilters,
  useRescheduleFiltersParams,
} from "../../../features/reschedule";
import { StickyFilterBar } from "../../../shared/ui/layouts/StickyFilterBar";
import { RescheduleFilterBar } from "./ui/RescheduleFilterBar";
import { RescheduleList } from "./ui/RescheduleList";

type Segment = "" | "RESCHEDULE" | "FOLLOW_UP" | "MATERIAL_ORDERED";

const hasNoAbsenceReason = (kind: Segment) => kind === "FOLLOW_UP" || kind === "MATERIAL_ORDERED";

export const ReschedulePage = () => {
  const [params, setParams] = useRescheduleFiltersParams();
  const filters = toRescheduleFiltersForm(params);
  const { counts } = useRescheduleFilters();

  const segments: { label: string; value: Segment; count?: number | null; hint?: string | null }[] = [
    { label: "Alle", value: "", count: counts?.all ?? null },
    { label: "Umdisponieren", value: "RESCHEDULE", count: counts?.reschedule ?? null },
    { label: "Folgetermin", value: "FOLLOW_UP", count: counts?.followUp ?? null },
    {
      label: "Material bestellt",
      value: "MATERIAL_ORDERED",
      count: counts?.materialOrdered ?? null,
      hint: counts?.materialOrderedDue ? `${counts.materialOrderedDue} fällig` : null,
    },
  ];

  const selectSegment = (kind: Segment) =>
    // A follow-up has no absence behind it, so a leftover Grund filter would hide every row.
    void setParams({ ...filters, kind, reason: hasNoAbsenceReason(kind) ? "" : filters.reason });

  return (
    <PageLayout pageTitle="Planungsbedarf">
      <div className="flex w-full flex-col gap-4">
        {/* The segment switch is part of the filter, so it is pinned with the bar. */}
        <StickyFilterBar>
          <div className="flex w-full flex-col gap-4">
            <SegmentedControl
              items={segments}
              value={filters.kind}
              onChange={selectSegment}
              ariaLabel="Art des Planungsbedarfs"
              className="!mb-0"
            />
            <RescheduleFilterBar />
          </div>
        </StickyFilterBar>
        <RescheduleList />
      </div>
    </PageLayout>
  );
};
